module.exports = __webpack_public_path__ + "img/files-primary.14deb2c7.svg";